import ClickOutside from "vue-click-outside";
import Velocity from "velocity-animate";
import { isSmallDevice } from "@/common/functions";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "MultiSortingDropdown",
    data() {
        return {
            isPopOutVisible: false,
            options: [
                { label: "sortingByVotes", value: "votes" },
                { label: "sortingByRelevance", value: "relevance" },
                { label: "sortingByAZ", value: "a-z" },
                { label: "sortingByZA", value: "z-a" }
            ],
            currentOption: 0
        };
    },
    computed: {
        ...mapGetters("Login", ["user"]),
        isSmallDevice,
        currentOptionLabel() {
            const idx = this.currentOption;
            const { label } = this.options[idx];
            return this.$t(label);
        }
    },
    methods: {
        ...mapActions("ThesaurusFilter", ["orderThesaurusBy"]),
        orderBy(id) {
            this.currentOption = id;
            this.orderThesaurusBy(this.options[id].value);
            this.$ga.event({
                eventCategory: "Sorting by",
                eventAction: this.options[id].value
            });
        },
        onOptionsMenuClickOutside() {
            this.isPopOutVisible = false;
        },

        // Sorting Options bg animation hooks
        enter(el, done) {
            Velocity(el, { translateX: "0" }, { duration: 370 });
            Velocity(
                el,
                { opacity: "0.35" },
                { queue: false },
                { duration: 350 },
                { complete: done }
            );
        },
        leave(el, done) {
            Velocity(el, { opacity: "0" }, { duration: 350 });
            Velocity(
                el,
                { translateX: "-100%" },
                { queue: false },
                { duration: 370 },
                { complete: done }
            );
        }
    },
    directives: {
        ClickOutside
    }
};



// WEBPACK FOOTER //
// ./src/components/Synonym/MultiSortingDropdown/MultiSortingDropdown.js